<template>
  <div class="d-flex flex-column align-center category-button" @click="$emit('click', { service })">
    <v-img 
      v-if="service.service_image_url && imageLoad" 
      class="rounded elevation-3 category-button-image" 
      :src="service.service_image_url" 
      @error="imageLoad = false"
    />
    <v-img
      v-else
      class="rounded elevation-3 category-button-image" 
      src="@/assets/missing-service-image.png" 
    />

    <div class="black--text category-button-text" style="font-size: 14px">{{ service.service }}</div>
  </div>
</template>

<script>
export default {
  name: 'ServiceButton',

  props: { service: Object },

  data: () => ({
    imageLoad: true,
  }),
}
</script>

<style scoped>
  .category-button {
    max-width: 192px;
  }
  
  .category-button.small {
    max-width: calc(50% - 6px);
  }

  .category-button-image {
    width: max-content;
    aspect-ratio: 16/9;
  }

  .category-button-text {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
